<template>
  <div class="control-category">
    <div class="content" v-if="!isEdit">
      {{item.name}}
      <div v-if="!disabled">
        <a class="btn add-article" href="javascript:;" @click.stop="add">
          <i class="header-icon el-icon-circle-plus" />
        </a>
        <a class="btn edit" href="javascript:;" @click.stop="edit">
          <i class="header-icon el-icon-edit" />
        </a>
        <a class="btn delete" href="javascript:;" @click.stop="del">
          <i class="header-icon el-icon-delete-solid" />
        </a>
      </div>
    </div>
    <div class="content" v-if="isEdit">
      <Input class="input" size="mini" v-model="item.name" placeholder="请输入内容" v-if="isEdit" />
      <div v-if="isEdit">
        <a class="btn add-article" href="javascript:;" @click.stop="confirm">
          <i class="header-icon el-icon-success" />
        </a>
        <a class="btn delete" href="javascript:;" @click.stop="cancel">
          <i class="header-icon el-icon-error" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Message } from 'element-ui'
import { editCategory } from '@/utils/service'

export default {
  name: 'control-category',
  props: {
    item: Object,
    level: Number,
    index: String,
    control: Function,
    disabled: Boolean,
  },
  components: { Input },
  data() {
    return {
      isEdit: false,
      name: this.item.name,
    }
  },
  methods: {
    add() {
      let num = this.index.split('.')
      this.control('add', {
        index: num,
        level: this.level,
        id: this.item.id,
      })
    },
    edit() {
      this.name = this.item.name
      this.isEdit = true
    },
    async confirm() {
      const { id, name } = this.item
      let response = await editCategory({ id, name })
      if (response.status) {
        this.isEdit = false
        Message({ message: '修改成功', type: 'success' })
      } else {
        Message.error('修改失败')
      }
    },
    cancel() {
      this.item.name = this.name
      this.isEdit = false
    },
    del() {
      let num = this.index.split('.')
      this.control('delete', {
        index: num,
        level: this.level,
        id: this.item.id,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './control_category.less';
</style>
